<template>
  <div id="MainView">
    <b-navbar toggleable="lg" type="dark" class="px-4 py-3">
      <b-nav-form class="navy-fields">
        <b-input-group class="rounded-pill">
          <template #prepend>
            <b-input-group-text class="rounded-tr-0 rounded-br-0 rounded-pill navy-fields form-control">
              <font-awesome-icon icon="search" />
            </b-input-group-text>
          </template>
          <template #append>
            <b-input-group-text class="rounded-tl-0 rounded-bl-0 rounded-pill navy-fields form-control">
              <b-badge variant="light">{{ filteredList('now').length + filteredList('earlier').length + filteredList('yesterday').length + filteredList('week').length + filteredList('older').length }}</b-badge>
            </b-input-group-text>
          </template>
          <b-form-input
            v-model="search"
            placeholder="Search for patient ..."
            style="width: 25rem;"
          ></b-form-input>
        </b-input-group>
      </b-nav-form>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav class="mr-4">
            <b-nav-item href="https://envisionit.ai/contact/" target="_blank" link-classes="btn px-3 btn-sm btn-yellow rounded-pill">
              <font-awesome-icon icon="info" />
            </b-nav-item>
          </b-navbar-nav>
          <!--
          <b-nav-item-dropdown right no-caret>
            <template v-slot:button-content>
              <font-awesome-icon icon="cog"></font-awesome-icon>
            </template>
            <b-dropdown-item href="#">Item 1</b-dropdown-item>
            <b-dropdown-item href="#">Item 2</b-dropdown-item>
            <b-dropdown-item href="#">Item 3</b-dropdown-item>
            <b-dropdown-item href="#">Item 4</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-navbar-nav>
            <b-nav-item href="#">
              <font-awesome-icon icon="bell"></font-awesome-icon>
            </b-nav-item>
          </b-navbar-nav>
          <a href="#" class="profile-icon box-shadow float-right ml-3">
            <span
              class="profile-img"
              :style="'background-image: url(' + require('@/assets/images/avatar-placeholder.jpg') + ')'"
            ></span>
            <span class="initials">JS</span>
          </a>
          -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="px-4 inner-container">
      <h5 class="pl-4 mt-2 title">
        Results
        <small>
          <a v-b-tooltip.hover.top="'Sort by date.'" href="#" @click.prevent="sorting = 'date'"><font-awesome-icon icon="calendar" size="xs" class="ml-1" :class="sorting !== 'date' ? 'color-white' : null" /></a>
          <a v-b-tooltip.hover.top="'Sort by AI detection.'" href="#" @click.prevent="sorting = 'priority'"><font-awesome-icon icon="sort-amount-up" size="xs" class="ml-1" :class="sorting !== 'priority' ? 'color-white' : null" /></a>
        </small>
      </h5>
      <b-row class="inner-row">
        <b-col cols="5" class="inner-col d-flex flex-column">
          <!-- Accordion -->
          <div class="accordion h-100 d-flex flex-column bg-dark-navy" role="tablist">
            <!-- Accordion 1 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-1>
                Just now
                <b-badge pill class="ml-2 bg-yellow color-black font-weight-400">{{ filteredList('now').length }}</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <list-view :list="filteredList('now')" :active="selected" v-on:study-selected="selectStudy"></list-view>
            </b-collapse>
            <!-- END | Accordion 1 -->

            <!-- Accordion 2 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-2>
                Ealier Today
                <b-badge pill class="ml-2 bg-yellow color-black font-weight-400">{{ filteredList('earlier').length }}</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <list-view :list="filteredList('earlier')" :active="selected" v-on:study-selected="selectStudy"></list-view>
            </b-collapse>
            <!-- END | Accordion 2 -->

            <!-- Accordion 3 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-3>
                Yesterday
                <b-badge pill class="ml-2 bg-yellow color-black font-weight-400">{{ filteredList('yesterday').length }}</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <list-view :list="filteredList('yesterday')" :active="selected" v-on:study-selected="selectStudy"></list-view>
            </b-collapse>
            <!-- END | Accordion 3 -->

            <!-- Accordion 4 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-4>
                This week
                <b-badge pill class="ml-2 bg-yellow color-black font-weight-400">{{ filteredList('week').length }}</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <list-view :list="filteredList('week')" :active="selected" v-on:study-selected="selectStudy"></list-view>
            </b-collapse>
            <!-- END | Accordion 4 -->

            <!-- Accordion 5 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-5>
                Older
                <b-badge pill class="ml-2 bg-yellow color-black font-weight-400">{{ filteredList('older').length }}</b-badge>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <list-view :list="filteredList('older')" :active="selected" v-on:study-selected="selectStudy"></list-view>
            </b-collapse>
            <!-- END | Accordion 5 -->

            <!-- Accordion 6 -->
            <b-card-header header-tag="header" class="p-0 flex-shrink-1" role="tab">
              <b-button block v-b-toggle.accordion-6 class="text-center color-yellow font-weight-900">
                Add Images
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel" class="flex-grow-1 overflow-y scroll-overflow h-100">
              <upload-files v-on:refresh-studies="refreshStudies"></upload-files>
            </b-collapse>
            <!-- END | Accordion 6 -->
          </div>
          <!-- END | Accordion -->
        </b-col>
        <b-col cols="7" class="inner-col d-flex flex-column">
          <result-view v-if="selected" :selected="selectedData" :key="selected"></result-view>
          <nothing-view v-else></nothing-view>
        </b-col>
      </b-row>
    </div>
    <b-modal id="disclaimer" size="xl" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="px-2">
        <h3 class="color-navy-blue mb-4">Disclaimer</h3>
        <b-row>
          <b-col cols="12" lg="3" class="mb-2">
            <h6 class="text-white">PLATFORM<br />DISCLAIMER</h6>
            <p>The information provided by Envisionit Deep AI (“Company”, “we”, “our”, “us”) on PULMIRA Triage Software-as-a-Medical-Device (the “Platform”) is for general informational purposes only. All information on the Platform is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Platform.<br /><br />
            Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the Platform or reliance on any information provided on or produced or published by the Platform. Your use of the Platform and your reliance on any information on the Platform is solely at your own risk.</p>
          </b-col>
          <b-col cols="12" lg="3" class="mb-2">
            <h6 class="text-white">PROFESSIONAL<br />DISCLAIMER</h6>
            <p>The services provided on the Platform are for the triage of pleural effusion and/or pneumothorax based on the information uploaded or provided to the Platform. All findings and/or reports generated by the Platform are based on a algorithmic analysis of the information uploaded or provided on the Platform using machine learning technology.<br /><br />
            The Platform therefore does not contain medical advice of any nature. The information is provided for general notification and is not a substitute for professional medical advice. Information produced or published by the Platform is intended to be used and must be used for notification purposes only and must be verified by an appropriately trained medical practitioner. Accordingly, before taking any actions based upon such information or relying on such information, you must consult an appropriately trained medical practitioner.<br /><br />
            The use or reliance of any information contained on this Platform is solely at your own risk.</p>
          </b-col>
          <b-col cols="12" lg="3" class="mb-2">
            <h6 class="text-white">LIMITATION<br />OF LIABILITY</h6>
            <p>The customer agrees and acknowledges that the Services do not give specific advice on individual patients and should only be used by authorised users acting within their clinical competencies. The Services are not a substitute for professional medical qualifications and are used at the customer's own risk.<br /><br />
            For the avoidance of doubt, Envisionit Deep AI is not liable for and does not guarantee compliance with any of the Customer's regulatory or legal obligations, including those which relate to patient care, medical advice, treatment, diagnosis and healthcare.<br /><br />
            The Customer assumes sole responsibility for results obtained from the use of the Services and the Documentation by the Customer, and for conclusions drawn from such use. Envisionit Deep AI shall have no liability for any damage caused by errors or omissions in any information or instructions, Images or scripts provided to Envisionit Deep AI by the Customer in connection with the Services, or any actions taken by Envisionit Deep AI at the Customer's direction.</p>
          </b-col>
          <b-col cols="12" lg="3" class="mb-2">
            <h6 class="text-white">&nbsp;<br /><br /></h6>
            <p>All warranties, representations, conditions and all other terms of any kind whatsoever implied by statute or common law are, to the fullest extent permitted by applicable law, excluded from this agreement; and the services  are provided to the Customer on an "as is" basis.</p>
            <h6 class="text-white">CONTACT US</h6>
            <p>Should you have any feedback, comments, requests for technical support or other inquiries, please contact us by email: <a href="mailto:info@envisionit.ai">info@envisionit.ai</a>.</p>
          </b-col>
        </b-row>
      </div>
      <p class="my-0 text-right">
        <b-button type="button" variant="link" href="#" @click.prevent="closeDisclaimer()">I've read &amp; accepted this disclaimer. <font-awesome-icon icon="arrow-right"></font-awesome-icon></b-button>
      </p>
    </b-modal>
  </div>
</template>

<script>
import { apiRoute, authHeader } from './../../helpers'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

import ListView from './components/List'
import NothingView from './components/Nothing'
import ResultView from './components/View'
import UploadFiles from './components/Upload'

export default {
  components: {
    ListView,
    NothingView,
    ResultView,
    UploadFiles
  },
  data () {
    return {
      current: null,
      interval: null,
      period: 'now',
      allLoaded: false,
      selected: null,
      search: null,
      now: [],
      earlier: [],
      yesterday: [],
      week: [],
      older: [],
      key: 0,
      disclaimerdisplayed: false,
      sorting: 'date'
    }
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      submissions: state => state.staffSubmission
    }),
    loadState () {
      return this.submissions.status.loaded
    },
    selectedData () {
      if (!this.selected) {
        return null
      } else {
        let _selected = this.now.find(item => item.created_at._id === this.selected)
        if (_selected) {
          return _selected.created_at.cell
        } else {
          _selected = this.earlier.find(item => item.created_at._id === this.selected)
          if (_selected) {
            return _selected.created_at.cell
          } else {
            _selected = this.yesterday.find(item => item.created_at._id === this.selected)
            if (_selected) {
              return _selected.created_at.cell
            } else {
              _selected = this.week.find(item => item.created_at._id === this.selected)
              if (_selected) {
                return _selected.created_at.cell
              } else {
                _selected = this.older.find(item => item.created_at._id === this.selected)
                if (_selected) {
                  return _selected.created_at.cell
                } else {
                  return null
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('staffSubmission', {
      getAllSubmissions: 'getCovid',
      clearSubmissions: 'clear'
    }),
    refreshStudies: function () {
      /*
      this.period = 'now'
      this.getAllSubmissions(this.period)
      */
    },
    filteredList: function (period) {
      if (!this[period]) {
        return []
      } else {
        if (!this.search) {
          return this[period]
        } else {
          return this[period].filter(row => (row.patient.demographics.name || row.patient.identifier).toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || row.patient.identifier.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        }
      }
    },
    displayResult: async function (data) {
      this.current = data

      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      const _response = await fetch(apiRoute() + '/api/v1/staff/covid/heatmaps/' + this.current.submission._id, requestOptions)
      const results = await _response.json()
      this.current.heatmaps = results
    },
    getConclusion: function (name) {
      if (name.indexOf('high') > -1) {
        return 'High Probability'
      } else if (name.indexOf('intermediate') > -1) {
        return 'Intermediate Probability'
      } else if (name.indexOf('low') > -1) {
        return 'Low Probability'
      } else if (name.indexOf('other') > -1) {
        return 'Other X-Rays'
      } else {
        return 'No Pathologies Found'
      }
    },
    getConclusionClass: function (name) {
      if (name.indexOf('high') > -1) {
        return 'text-danger'
      } else if (name.indexOf('intermediate') > -1) {
        return 'text-warning'
      } else {
        return 'text-success'
      }
    },
    getCurrentClass: function (_id) {
      if (this.current && this.current.submission) {
        if (this.current.submission._id === _id) {
          console.log('Selected')
          return 'selected-row'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    originalImage: function (result) {
      if (result) {
        return apiRoute() + result.attachments[0].path
      } else {
        return null
      }
    },
    boundingBoxes: function (result) {
      if (result) {
        return apiRoute() + result.attachments[0].response.bounding.path
      } else {
        return null
      }
    },
    hasCardiomegaly: function (result) {
      if (result) {
        const _pathology = result.attachments[0].response.labels[0].pathologies.find(pathology => pathology.predicted_diagnosis === 'cardiomegaly')
        if (_pathology) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    selectStudy: async function (id) {
      this.selected = id
    },
    closeDisclaimer: function () {
      this.$bvModal.hide('disclaimer')
      this.disclaimerdisplayed = true
      localStorage.setItem('disclaimerdisplayed', 'yes')
    }
  },
  created () {
    const _disclaimerdisplayed = localStorage.getItem('disclaimerdisplayed')
    if (_disclaimerdisplayed === 'yes') {
      this.disclaimerdisplayed = true
    }
  },
  mounted () {
    this.getAllSubmissions(this.period)

    if (!this.disclaimerdisplayed) {
      this.$bvModal.show('disclaimer')
    }
  },
  destroyed () {
    clearInterval(this.interval)
    this.interval = null
  },
  watch: {
    loadState (loaded) {
      if (loaded && this.alert.message == null && this.alert.type == null) {
        const getSort = function (name) {
          if (name.indexOf('high') > -1) {
            return 5
          } else if (name.indexOf('intermediate') > -1) {
            return 4
          } else if (name.indexOf('low') > -1) {
            return 3
          } else {
            return 0
          }
        }

        const rowData = this.submissions.info[this.period]
        if (rowData) {
          this[this.period] = []
          rowData.forEach(row => {
            if (!row.submission.patient) {
              row.submission.patient = {
                _id: row.submission._id,
                clinical: {},
                created_at: row.submission.created_at,
                demographics: {
                  ageGroup: 'Unknown',
                  country: 'Unknown',
                  gender: 'Unknown',
                  province: 'Unknown'
                },
                identifier: row.submission.study_id
              }
            }

            const _record = {
              created_at: { date: moment(row.submission.created_at).toDate(), raw_date: moment(row.submission.created_at), _id: row.submission._id, cell: row },
              conclusion: row.analysis.conclusion.toLowerCase(),
              type: undefined,
              score: row.analysis.score,
              patient: row.submission.patient,
              sort: getSort(row.analysis.conclusion.toLowerCase()),
              feedback: false
            }

            if (row.submission.attachments && row.submission.attachments.length > 0 && row.submission.attachments[0].feedback) {
              _record.feedback = true
            }

            this[this.period].push(_record)
          })

          if (this.sorting === 'date') {
            this[this.period].sort((a, b) => {
              return (a.created_at.raw_date < b.created_at.raw_date) ? 1 : -1
            })
          } else {
            this[this.period].sort((a, b) => {
              return (a.score < b.score) ? 1 : -1
            })
          }

          if (this.period === 'now') {
            this.period = 'earlier'
            this.getAllSubmissions(this.period)
          } else if (this.period === 'earlier') {
            if (!this.allLoaded) {
              this.period = 'yesterday'
              this.getAllSubmissions(this.period)
            }
          } else if (this.period === 'yesterday') {
            if (!this.allLoaded) {
              this.period = 'week'
              this.getAllSubmissions(this.period)
            }
          } else if (this.period === 'week') {
            if (!this.allLoaded) {
              this.period = 'older'
              this.getAllSubmissions(this.period)
            }
          } else {
            this.allLoaded = true
            const self = this
            if (!this.interval) {
              this.interval = setInterval(() => {
                self.period = 'now'
                self.getAllSubmissions(this.period)
              }, 30000)
            }
          }
        } else {
          if (this.submissions.info && this.submissions.info._id) {
            const _id = this.submissions.info._id
            const _record = this.submissions.info[_id]

            const _periods = ['now', 'earlier', 'yesterday', 'week', 'older']
            _periods.forEach(_period => {
              let _previous = this[_period].find(__record => __record.created_at._id === _id)
              if (_previous) {
                const _index = this[_period].findIndex(__record => __record.created_at._id === _id)
                if (!_record.submission.patient) {
                  _record.submission.patient = {
                    _id: _record.submission._id,
                    clinical: {},
                    created_at: _record.submission.created_at,
                    demographics: {
                      ageGroup: 'Unknown',
                      country: 'Unknown',
                      gender: 'Unknown',
                      province: 'Unknown'
                    },
                    identifier: _record.submission.study_id
                  }
                }

                _previous = {
                  created_at: { date: moment(_record.submission.created_at).toDate(), raw_date: moment(_record.submission.created_at), _id: _record.submission._id, cell: _record },
                  conclusion: _record.analysis.conclusion.toLowerCase(),
                  type: undefined,
                  score: _record.analysis.score,
                  patient: _record.submission.patient,
                  sort: getSort(_record.analysis.conclusion.toLowerCase()),
                  feedback: false
                }

                if (_record.submission.attachments && _record.submission.attachments.length > 0 && _record.submission.attachments[0].feedback) {
                  _previous.feedback = true
                }

                this.$set(this[_period], _index, _previous)
                this.selected = null
                this.$nextTick(() => {
                  this.selected = _id
                })
              }
            })
          }
        }
      }
    },
    sorting () {
      const _periods = ['now', 'earlier', 'yesterday', 'week', 'older']
      _periods.forEach(_period => {
        if (this.sorting === 'date') {
          this[_period].sort((a, b) => {
            return (a.created_at.raw_date < b.created_at.raw_date) ? 1 : -1
          })
        } else {
          this[_period].sort((a, b) => {
            return (a.score < b.score) ? 1 : -1
          })
        }
      })
    }
  }
}
</script>
